module.exports = __webpack_public_path__ + "static/media/Archia-Regular.572458e2.otf";